"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.initialValuesConfig = exports.idPrefix = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'modal';
var idPrefix = exports.idPrefix = 'mc_';
var dropdownOptions = exports.dropdownOptions = {
  paymentFrequency: ['semi-annual', 'quarterly', 'monthly']
};
var propsConfig = exports.propsConfig = {
  config: {
    Icon: 'icon-handshake-black',
    Label: 'Modal Charge APR',
    HasBorder: true,
    Steps: [{
      Title: 'What is my modal charge and annual percentage rate?',
      Description: '',
      SecondaryDescription: 'As a MassMutual policyowner, you can choose the premium payment plan option that best fits your needs. Use our calculator to determine the total dollar amount and the Annual Percentage Rate (APR) for any additional charge you may incur if you pay your annual premium in semi-annual, quarterly or monthly installments.',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Calculate',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Your Results',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next Step',
        Description: 'Log in to make changes to your payment terms',
        CTAList: [{
          Label: 'Log In',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};
var validationConfigPage1 = yup.object().shape({
  annualPremium: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  payment: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000').test((info, meta) => {
    var {
      annualPremium,
      paymentFrequency
    } = meta.parent;
    return totalPaymentGreaterOrEqualToAnnualPremium(paymentFrequency, annualPremium, info) ? true : meta.createError({
      path: meta.path,
      message: 'Modal payments must total at least the annual premium'
    });
  }).test((info, meta) => {
    var {
      annualPremium
    } = meta.parent;
    return singlePaymentSmallerThanAnnualPremium(annualPremium, info) ? true : meta.createError({
      path: meta.path,
      message: 'Modal payments must be less than annual premium'
    });
  }),
  paymentFrequency: yup.string().required('You must select a payment frequency')
});
var validationConfig = exports.validationConfig = [validationConfigPage1];
var initialValuesConfig = exports.initialValuesConfig = {
  annualPremium: '',
  paymentFrequency: '',
  payment: ''
};
function totalPaymentGreaterOrEqualToAnnualPremium(paymentFrequency, annualPremium, scheduledPremium) {
  var multiplicationMap = {
    'semi-annual': 2,
    quarterly: 4,
    monthly: 12
  };
  return scheduledPremium * multiplicationMap[paymentFrequency] >= annualPremium;
}
function singlePaymentSmallerThanAnnualPremium(annualPremium, scheduledPremium) {
  return scheduledPremium < annualPremium;
}